// extracted by mini-css-extract-plugin
export default {"wrapper":"Reviews_wrapper__-5lZe","background":"Reviews_background__Yafdj"};